import { CommonModule } from '@angular/common';
import { Component, HostBinding, input, OnDestroy, Optional, inject } from '@angular/core';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { PageService } from '@vendasta/galaxy/page/src/page.service';
import { ViewModeService } from '../../../core/src/lib/view-mode.service';

@Component({
  selector: 'inbox-inbox',
  imports: [CommonModule, RouterModule, MatSidenavModule],
  styleUrls: ['./inbox.component.scss'],
  templateUrl: './inbox.component.html',
})
export class InboxComponent implements OnDestroy {
  @HostBinding('class') class = 'inbox-inbox';

  modeType = input<MatDrawerMode>('over');
  disabled = input<boolean>(false);

  protected readonly viewModeService = inject(ViewModeService);

  constructor(@Optional() private pageService: PageService) {
    this.class = `inbox`;
  }

  ngOnDestroy(): void {
    if (this.pageService) {
      this.pageService.pop();
    }
  }
}
